export const updateObject = (oldObject, updatePropertise) => {
  return {
    ...oldObject,
    ...updatePropertise
  };
};
